
const UpDownArrows = () => {
    
    return (
        <div className="up-down-wraper1">
            <span className="up-arrow">
            <svg width="11" height="17" viewBox="0 0 11 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.5 2.5L5.5 15M9 5.6L5.5 2L2 5.6H9Z" stroke="#EBF9E9" strokeWidth="2.4986" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            </span>
            <span className="down-arrow">
                <svg width="11" height="17" viewBox="0 0 11 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5.5 14.5V2M2 11.4L5.5 15L9 11.4H2Z" stroke="#FDE2DF" strokeWidth="2.4986" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
            </span>
        </div>
    )
}

export default UpDownArrows